import { useEffect, useState } from 'react';
import { ListContainer, List, ListItem, Checkbox, ButtonColumn, Container, ListContainerHeader } from './transfer-list-checkbox.style';
import IconButtonComponent from '../icon-button';
import { ChevronDoubleRightSvg, ChevronRightSvg, EmptySvg } from '../../assets/svgs';
// import BadgeComponent from '../badge';
import EmptyModalComponent from '../empty-modal';
import PropTypes from 'prop-types';

// Helper functions
function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}
function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

const TransferListCheckbox = ({ data, name, value, onChange, update, disabled }) => {
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState(data ? not([ ...data ], value) : []);
  const [right, setRight] = useState(value || []);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    if (disabled) return;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleAllRight = () => {
    if (disabled) return;
    setRight(right.concat(left));
    setLeft([]);
    setChecked(not(checked, left));
    onChange({ target: { name, value: right.concat(left) } });
  };

  const handleAllLeft = () => {
    if (disabled) return;
    setLeft(left.concat(right));
    setRight([]);
    setChecked(not(checked, right));
    onChange({ target: { name, value: [] } });
  };

  const handleCheckedRight = () => {
    if (disabled) return;
    const newRight = right.concat(leftChecked);
    setRight(newRight);
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
    onChange({ target: { name, value: newRight } });
  };

  const handleCheckedLeft = () => {
    if (disabled) return;
    setLeft(left.concat(rightChecked));
    const newRight = not(right, rightChecked);
    setRight(newRight);
    setChecked(not(checked, rightChecked));
    onChange({ target: { name, value: newRight } });
  };

  useEffect(() => {
    setLeft(data ? not([ ...data ], value) : []);

    if (!update) {
      setRight(value || []);
    }
  }, [data, value]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderList = ({ data, label, emptyText }) => (
    <ListContainer className='custom-scrollbar'>
      <ListContainerHeader $isempty={data?.length === 0}>
        {label}
        <span>{data?.filter(item => checked?.includes(item))?.length || 0}/{data?.length || 0} selected</span>
      </ListContainerHeader>
      {
        data && data?.length > 0 ? (
          <List>
            {
              data?.map((value, index) => (
                <ListItem
                  key={index}
                  selected={checked.indexOf(value) !== -1}
                  onClick={handleToggle(value)}
                >
                  <Checkbox
                    checked={checked.indexOf(value) !== -1}
                    onChange={handleToggle(value)}
                    onClick={e => e.stopPropagation()}
                    disabled={disabled}
                  />
                  {value?.label}
                  {/* {
                    value?.scheme?.label &&
                    <BadgeComponent label={value?.scheme?.label} type="warning" outline />
                  } */}
                  {
                    value?.scheme?.logo &&
                    <img src={value?.scheme?.logo} alt={value?.scheme?.label} style={{ width: '100%', maxWidth: 30, height: 'auto' }} />
                  }
                </ListItem>
              ))
            }
          </List>
        ) : (
          <EmptyModalComponent text={emptyText} icon={EmptySvg} />
        )
      }
    </ListContainer>
  );

  return (
    <Container>
      {renderList({ data: left, label: 'Choices', emptyText: 'No bins found!' })}
      <ButtonColumn>
        <IconButtonComponent icon={ChevronDoubleRightSvg} onClick={handleAllRight} size="small" outline disabled={left.length === 0 || disabled} />
        <IconButtonComponent icon={ChevronRightSvg} onClick={handleCheckedRight} size="small" outline={leftChecked.length === 0 ? true :false} disabled={leftChecked.length === 0 || disabled} />
        <IconButtonComponent icon={ChevronRightSvg} onClick={handleCheckedLeft} size="small" outline={rightChecked.length === 0 ? true :false} disabled={rightChecked.length === 0 || disabled} style={{ transform: `rotate(180deg)` }} />
        <IconButtonComponent icon={ChevronDoubleRightSvg} onClick={handleAllLeft} size="small" outline disabled={right.length === 0 || disabled} style={{ transform: `rotate(180deg)` }} />
      </ButtonColumn>
      {renderList({ data: right, label: 'Chosen', emptyText: 'No bins selected!' })}
    </Container>
  );
};

TransferListCheckbox.propTypes = {
  data: PropTypes.array,
  name: PropTypes.string.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  update: PropTypes.bool,
  disabled: PropTypes.bool
};

export default TransferListCheckbox;
